<div class="image-frame"
    [ngStyle]="{'background-image': 'url(' + (preview || oldImageURL || 'assets/images/image_preview_default.png') + ')'}">
  <div class="fileUpload m-10" (click)="excelFileInput.click()" *ngIf="isUploadable">
    <input id="excelFileInput" #excelFileInput type="file" class="upload" (change)="uploadImage($event)" accept="image/*"
           hidden />
  </div>
</div>

